// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"67323058","952":"a17af45e"}[chunkId] + ".chunk.js";
};